// Unique code to get top level Page Component and Page SCSS
import React from 'react';
// All boilerplate cut/paste stuff
import ReactDOM from 'react-dom/client';
import { Provider as PageContext } from '../../../contexts/PageContext';
// The only thing different is the from part should match your component
import PAGE_COMPONENT from './InviteConnections';

// eslint-disable-next-line no-undef
const props = globalPageProps || {};

ReactDOM.hydrateRoot(
    document.getElementById('root'),
    <PageContext PAGE_PROPS={props.PAGE_PROPS}>
        <PAGE_COMPONENT {...props} />
    </PageContext>
);

// TO USE THIS COMPONENT IN THE BACKEND:

/**
 
*  To render the component:
*
*  req.reactRender = {
*      componentPath: 'User/InviteConnections/InviteConnections,
*      props: {},
*      metaTagData:{}
*  }
*
*  next();
*  return;
*

 */
